import { AES, enc } from 'crypto-js';
import { RuntimeConfiguration } from '@/configuration';

export const encryptData = (data: unknown, secretKey: string): string => {
  const encryptedData = AES.encrypt(JSON.stringify(data), secretKey).toString();

  return encryptedData;
};

export const encryptWallet = (data: unknown): string => {
  const secretKey = RuntimeConfiguration.SECRET_KEY;

  try {
    const stringifiedData = JSON.stringify(data);
    const encryptedData = AES.encrypt(stringifiedData, secretKey).toString();

    return encryptedData;
  } catch (err) {
    console.error('Error during encryption:', err);

    return '';
  }
};

export const decryptWallet = (encryptedData: string): unknown => {
  const secretKey = RuntimeConfiguration.SECRET_KEY;

  try {
    const decryptedData = AES.decrypt(encryptedData, secretKey)?.toString(enc.Utf8);

    return decryptedData;
  } catch (err) {
    console.error('Error during decryption:', err);
    console.log(err);
  }
};
